import { includes } from 'lodash';
import SharedStrategy from './SharedStrategy';
import refundStrategy from './RefundStrategy';
import paymentStrategy from './PaymentStrategy';

const errorCodesToSkip = ['canceled'];
export const shouldShowError = error => !includes(errorCodesToSkip, error.code);

export const getNormalizedErrorMessage = (error) => {
  switch (error.code) {
    case 'reader_error':
      return 'Error connecting to Reader. Try again, please.';
    default:
      return error.message;
  }
};

const strategies = [paymentStrategy, refundStrategy];

export const getStrategyByName = (name) => {
  const strategy = strategies.find(s => s.getName() === name);

  if (!strategy) {
    const availableStrategies = `[${strategies.map(s => `'${s.getName()}'`).join(', ')}]`;
    throw new Error(`Strategy '${name}' is not found. Available strategies: ${availableStrategies}`);
  }

  return strategy;
};

export const getSharedStrategy = () => new SharedStrategy('shared');

